var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.086,
    height: 26,
    viewBox: "0 0 25.086 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf_1_",
    transform: "translate(-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    d: "M83.373,209H81.762a.762.762,0,0,0-.762.764l.011,5.786a.762.762,0,1,0,1.523,0v-1.757l.839,0a2.4,2.4,0,1,0,0-4.791Zm0,3.267-.843,0c0-.324,0-.674,0-.875,0-.172,0-.533,0-.872h.848a.872.872,0,1,1,0,1.744Z",
    transform: "translate(-68.344 -198.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    d: "M211.353,209h-1.591a.762.762,0,0,0-.762.763s.011,5.6.011,5.619a.762.762,0,0,0,.762.759h0c.048,0,1.183,0,1.637-.012,1.721-.03,2.97-1.526,2.97-3.558C214.383,210.435,213.165,209,211.353,209Zm.033,5.605c-.2,0-.537.006-.854.008,0-.662-.006-3.4-.007-4.09h.828c1.4,0,1.507,1.567,1.507,2.047C212.859,213.57,212.4,214.587,211.386,214.605Z",
    transform: "translate(-189.844 -198.387)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    d: "M356.091,209.365a.762.762,0,1,0,0-1.523h-2.329a.762.762,0,0,0-.762.762v5.746a.762.762,0,1,0,1.523,0v-2.166h1.382a.762.762,0,0,0,0-1.523h-1.382v-1.3Z",
    transform: "translate(-326.531 -197.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    d: "M31.8,7.363h-.559V7.146A3.794,3.794,0,0,0,30.2,4.526L27.034,1.188A3.825,3.825,0,0,0,24.27,0H14.129a2.288,2.288,0,0,0-2.285,2.285V7.363h-.559A2.288,2.288,0,0,0,9,9.648v9.141a2.288,2.288,0,0,0,2.285,2.285h.559v2.641A2.288,2.288,0,0,0,14.129,26H28.957a2.288,2.288,0,0,0,2.285-2.285V21.074H31.8a2.288,2.288,0,0,0,2.285-2.285V9.648A2.288,2.288,0,0,0,31.8,7.363ZM13.367,2.285a.763.763,0,0,1,.762-.762H24.27a2.3,2.3,0,0,1,1.658.713l3.164,3.337a2.276,2.276,0,0,1,.627,1.572v.217H13.367Zm16.352,21.43a.763.763,0,0,1-.762.762H14.129a.763.763,0,0,1-.762-.762V21.074H29.719Zm2.844-4.926a.763.763,0,0,1-.762.762H11.285a.763.763,0,0,1-.762-.762V9.648a.763.763,0,0,1,.762-.762H31.8a.763.763,0,0,1,.762.762Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf_icon.81956e7800323b4432dd6b77da1804bd.svg";
export { ForwardRef as ReactComponent };